module.exports = __webpack_public_path__ + "static/media/2.1414a715.svg";